import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Loader } from '@googlemaps/js-api-loader'
    import { onMounted, ref, toRefs, watch } from 'vue'

    interface Props {
        center?: string|null
        origin?: string|null
        destination?: string|null
        travelMode?: TravelMode|null
        marker?: string|null
        zoom?: number
    }

    enum TravelMode {
        BICYCLING = 'BICYCLING',
        DRIVING = 'DRIVING',
        TRANSIT = 'TRANSIT',
        WALKING = 'WALKING',
    }

    
export default /*#__PURE__*/_defineComponent({
  props: {
    center: { default: null },
    origin: { default: null },
    destination: { default: null },
    travelMode: { default: null },
    marker: { default: null },
    zoom: { default: 15 }
  },
  setup(__props: any) {

const props = __props as { center: string|null, origin: string|null, destination: string|null, travelMode: TravelMode|null, marker: string|null, zoom: number }

    

    const { center, origin, destination, travelMode, marker, zoom } = toRefs(props)
    const mapElement = ref<HTMLElement>()
    const loader = new Loader({
        apiKey: 'AIzaSyACIjqaQKMV_NdVKNjE21csDsHEQl86cH4',
        version: 'weekly',
        libraries: ['places'],
    })

    onMounted(async() => {
        if (!mapElement.value) {
            return
        }

        const google = await loader.load()
        const geocoder = new google.maps.Geocoder()
        const directionsService = new google.maps.DirectionsService()
        const directionsRenderer = new google.maps.DirectionsRenderer()

        const getLatLng = async(address: string|null|undefined) => {
            const result = await geocoder.geocode({
                address,
            })

            return result.results[0]?.geometry.location
        }

        const map = new google.maps.Map(mapElement.value, {
            scrollwheel: true,
            center: await getLatLng(center.value ?? marker.value ?? origin.value),
            zoom: zoom.value,
        })

        const updateDirections = async(): Promise<void> => {
            if (!origin?.value || !destination?.value) {
                directionsRenderer.set('directions', null)

                return
            }

            const result = await directionsService.route({
                origin: origin.value,
                destination: destination.value,
                travelMode: travelMode.value ?? TravelMode.DRIVING,
            })

            directionsRenderer.setDirections(result)
        }

        const updateMarker = async(): Promise<void> => {
            if (marker.value) {
                const position = await getLatLng(marker.value)
                map.setCenter(position)
                new google.maps.Marker({
                    animation: google.maps.Animation.DROP,
                    map,
                    position,
                })
            }
        }

        const updateCenter = async(): Promise<void> => {
            if (center.value) {
                map.setCenter(await getLatLng(center.value))
            }
        }

        const updateZoom = async(): Promise<void> => {
            if (zoom.value) {
                map.setZoom(zoom.value)
            }
        }

        directionsRenderer.setMap(map)

        watch(center, updateCenter)
        watch(origin, updateDirections)
        watch(destination, updateDirections)
        watch(travelMode, updateDirections)
        watch(marker, updateMarker)
        watch(zoom, updateZoom)

        updateDirections()
        updateMarker()
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "mapElement",
    ref: mapElement
  }, null, 512))
}
}

})